import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import GroupState from './state';
import { MutationTypes } from './mutation-types';
import { GroupModel } from '@/models/Group';
import { BaseGroupingStrategy } from '@/helper/groupingStrategy';
import { BaseDecideOddsStrategy } from '@/helper/decideOddsStrategy';

type Context = ActionContext<GroupState, RootState>;
const actions: ActionTree<GroupState, RootState> = {
    reset(context: Context, isForce: boolean) {
        if (isForce) {
            context.commit(MutationTypes.RESET);
        }
    },

    setGroup(context: Context, groups: GroupModel[]) {
        context.commit(MutationTypes.LOAD, groups);
    },

    drawGroup(context: Context) {
        const groups = context.getters.drawableGroups;
        const random = Math.random() * 100;
        let hitIdx = 1;
        let sumOdds = 0;
        for (hitIdx; hitIdx <= groups.length; hitIdx++) {
            if (sumOdds < random && random <= sumOdds + groups[hitIdx].drawOdds) {
                break;
            }
            sumOdds += groups[hitIdx].drawOdds;
        }
        context.commit(MutationTypes.SET_DRAWED, groups[hitIdx]);
    },

    changeGroupingStrategy(context: Context, groupingStrategy: BaseGroupingStrategy) {
        context.commit(MutationTypes.CHANGE_GROUPING_STRATEGY, groupingStrategy);
    },

    changeOddsStrategy(context: Context, decideOddsStrategy: BaseDecideOddsStrategy) {
        context.commit(MutationTypes.CHANGE_ODDS_STRATEGY, decideOddsStrategy);
    },

    changedDrawable(context: Context) {
        context.state.decideOddsStrategy.decideOdds(context.state.groups);
    },
};

export default actions;
